import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { SettingsRail } from './SettingsRail';

export function SettingsLayout({ children }: { children?: ReactNode }) {
  return (
    <div className="ats-fullscreen-shell">
      <SettingsRail />
      <div className="ats-fullscreen-content">{children ?? <Outlet />}</div>
    </div>
  );
}
